import { CLEAR_ALL_DATA } from '../actionTypes';

export const clearAllData = () => ({
  type: CLEAR_ALL_DATA,
});
